function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Limitless imports
// import AttachmentBody from "../../attachment-body/AttachmentBody";
import CustomerDialogueWrapper from "../customer-dialogue-wrapper/CustomerDialogueWrapper";
import { DialogueBody } from "../../../../../customer/components";
import withStyles from "@mui/styles/withStyles";
import { AttachmentBody } from "../../../../../customer/components";
const CustomerAttachmentDialogue = ({
  classes,
  dialogue,
  ...rest
}) => {
  const {
    body,
    attachments
  } = dialogue;
  const hasBody = typeof body === "string";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(CustomerDialogueWrapper, _extends({
    dialogue: dialogue
  }, rest, {
    isCustomerAttachment: true
  }), /*#__PURE__*/React.createElement("div", null, attachments && attachments.map((attachment, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(AttachmentBody, {
      attachment: attachment,
      backgroundStyle: classes.background
    }), hasBody && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DialogueBody, {
      body: body,
      textStyling: classes.bodyText
    })));
  })))));
};
const styles = ({
  palette
}) => ({
  bodyText: {
    color: palette.primary.dark
  },
  background: {
    margin: "auto auto 8px auto"
  }
});
export default withStyles(styles)(CustomerAttachmentDialogue);
CustomerAttachmentDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired
};